var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "airport_",
    "data-name": "airport ",
    transform: "translate(-510 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 72,
    height: 72,
    rx: 12,
    transform: "translate(510 169)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "airport_icon",
    "data-name": "airport icon",
    transform: "translate(522 181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 48,
    height: 48,
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(4 14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M-1456.4,2578.846h4.27a.652.652,0,0,1,.554.314l7.8,12.936a.645.645,0,0,1,.009.651.646.646,0,0,1-.563.327h-6.077a.644.644,0,0,1-.587-.374l-5.994-12.932a.645.645,0,0,1,.041-.621A.649.649,0,0,1-1456.4,2578.846Zm3.905,1.294h-2.894l5.4,11.642h4.518Z",
    transform: "translate(1467.103 -2578.846)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M-1460.887,2598a6.371,6.371,0,0,1-1.983-.321,5.817,5.817,0,0,1-3.686-3.792c-1.457-4.126-2.589-7.5-2.6-7.536a.649.649,0,0,1,.087-.585.64.64,0,0,1,.523-.267h4.3a.642.642,0,0,1,.587.382l2.47,5.494,5.944-.929a.646.646,0,0,1,.736.54.643.643,0,0,1-.537.737l-6.43,1a.643.643,0,0,1-.686-.373l-2.5-5.563h-2.984c.427,1.258,1.286,3.779,2.3,6.664a4.575,4.575,0,0,0,4.775,3.239.59.59,0,0,1,.078,0h28.914a1.287,1.287,0,0,0,.987-.531c.16-.3.278-1.042-.708-2.7a6.5,6.5,0,0,0-4.448-2.962,10.157,10.157,0,0,0-2.907-.2l-7.168.771a.65.65,0,0,1-.711-.576.648.648,0,0,1,.574-.711l7.165-.771a11.3,11.3,0,0,1,3.276.212,7.848,7.848,0,0,1,5.326,3.572c1.005,1.685,1.253,3.028.733,3.985a2.607,2.607,0,0,1-2.077,1.2h-28.924C-1460.526,2597.99-1460.678,2598-1460.887,2598Z",
    transform: "translate(1469.189 -2579.796)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    d: "M2.156,1.293a.862.862,0,1,0,.862.862.863.863,0,0,0-.862-.862M2.156,0A2.156,2.156,0,1,1,0,2.156,2.156,2.156,0,0,1,2.156,0Z",
    transform: "translate(18.705 17.326)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    d: "M2.156,1.293a.862.862,0,1,0,.862.862.863.863,0,0,0-.862-.862M2.156,0A2.156,2.156,0,1,1,0,2.156,2.156,2.156,0,0,1,2.156,0Z",
    transform: "translate(24.725 17.326)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M-1426.581,2593.976h-6.035a.647.647,0,0,1-.647-.647.648.648,0,0,1,.647-.649h6.035a.647.647,0,0,1,.647.649A.646.646,0,0,1-1426.581,2593.976Z",
    transform: "translate(1464.211 -2580.782)",
    fill: "#19bc9c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.1ff7c13809bfe1e97402b51e6dd933c8.svg";
export { ForwardRef as ReactComponent };